module.exports = __webpack_public_path__ + "static/media/track-product-overview-graphics.484d4d94.png";